import { UIButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { $el } from '../lib/ui/elements';
import { uiReplaceI18N } from '../lib/ui/functions';
import { $analytics } from '../lib/y/analytics';
import { $i18n } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { $storage } from '../lib/y/storage';

export class HomeConsentDialog extends UIDialog {
    constructor() {
        super({ classes: 'm-440 c-light m-mobile-fs m-at-bottom' });

        const privacy_link = $el.SPAN('t-underline u-clickable', $i18n.tl.consent_link);
        privacy_link.addEventListener('click', () => {
            this.dismiss(true);
            $location.navigate(['privacy']);
        });

        this.content.ui_add($el.DIV('w-block', [
            $el.H2('title', $i18n.tl.consent_title),
            $el.P('text', uiReplaceI18N($i18n.tl.consent_text, privacy_link)),
            $el.DIV('s-small'),
            $el.DIV('l-button-row b b-content', [
                new UIButton({
                    title: $i18n.tl.consent_preferences, kind: 'k-text', classes: ['ui-tint-reverse', 'm-hollow'], on_click: () => {
                        $storage.putString('abundo_consent_done', 'yes', true);
                        (window as any).consentManager.openConsentManager();
                        this.dismiss(true);
                    }
                }),
                new UIButton({
                    title: $i18n.tl.consent_accept, classes: 'ui-tint-reverse', on_click: () => {
                        $storage.putString('abundo_consent_done', 'yes', true);
                        $storage.putString('abundo_consent_accepted', 'yes', true);
                        $analytics.finishInitSegment();
                        this.dismiss(true);
                    }
                })
            ]),
        ]));
    }
}
